import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const createRole = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.ROLE_ENDPOINT + "/create", payload, token);
        return response;
    } catch (err) {
        console.log("Error in createRole service :", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
};

export const updateRole = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.ROLE_ENDPOINT + "/update", payload, token);
        return response;
    } catch (err) {
        console.log("Error in updateRole service :", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
};

export const deactivateRole = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.ROLE_ENDPOINT + "/deactivate", payload, token);
        return response;
    } catch (err) {
        console.log("Error in updateRole service :", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
};

export const fetchRoles = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.ROLE_ENDPOINT + "/fetch", payload, token);
        return response;
    } catch (err) {
        console.log("Error in fetchRoles service :", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
};

export const savePermissions = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.PERMISSION_ENDPOINT + "/save", payload, token);
        return response;
    } catch (err) {
        console.log("Error in savePermissions : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const fetchPermissions = async (payload) => {
    try {
        const token = getToken();
        const { roleId } = payload;
        const response = await apiService.get(API_URL.PERMISSION_ENDPOINT + `/fetch/${roleId}`, token);
        return response;
    } catch (err) {
        console.log("Error in fetchPermissions : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}
